import { gql } from "@outschool/ui-apollo";

export const BLOCK_SCOPED_THREAD_DETAIL_QUERY = gql`
  query BlockScopedThreadDetail($threadUid: ID!) {
    blockScopedThread(threadUid: $threadUid) {
      uid
      classPost {
        uid
        title
      }
      learningAssignmentClassPost {
        uid
        title
      }
      messages {
        uid
        sender {
          uid
          name
          photo
          isLearner
        }
        messageContent {
          uid
          text
          attachments {
            uid
            fileUrl
            file {
              filename
              mimetype
              size
              url
              thumbUrl
            }
            conversionStatus
            created_at
          }
          video {
            uid
            fileUrl
            file {
              filename
              mimetype
              size
              url
              thumbUrl
            }
            conversionStatus
            created_at
          }
        }
        sentAt
      }
    }
  }
`;
